import type { enStok } from '../en/stok';

export const idStok: Record<keyof typeof enStok, string> = {
  // ---- Navigation -----------------------------------------------------------------------
  'stok.nav.stock': 'Stok',
  'stok.nav.replenishment': 'Perencanaan',
  'stok.nav.group.purchasing': 'Pembelian',
  'stok.nav.group.operations': 'Operasional',
  'stok.nav.valuation': 'Valuasi',
  'stok.nav.movements': 'Mutasi',
  'stok.nav.opening': 'Saldo awal',
  'stok.nav.lots': 'Lot & kedaluwarsa',
  'stok.nav.receipts': 'Penerimaan',
  'stok.nav.purchaseOrders': 'Pesanan pembelian',
  'stok.nav.sourcing': 'Penawaran & perjanjian',
  'stok.nav.suppliers': 'Pemasok',
  'stok.nav.waste': 'Waste',
  'stok.nav.counts': 'Stok opname',
  'stok.nav.masterData': 'Data induk',
  'stok.nav.masterDataLabel': 'Bagian data induk',
  'stok.nav.purchaseRequests': 'Permintaan pembelian',
  'stok.nav.transfers': 'Transfer',
  'stok.nav.consumption': 'Pemakaian',
  'stok.nav.recalls': 'Recall',
  'stok.nav.lotsSections': 'Bagian lot',
  'stok.nav.countsSections': 'Bagian stok opname',
  'stok.nav.countAccuracy': 'Akurasi',
  'stok.nav.items': 'Barang',
  'stok.nav.locations': 'Lokasi',

  // ---- Pengadaan pemasok ---------------------------------------------------------------
  'stok.sourcing.title': 'Pengadaan pemasok',
  'stok.sourcing.subtitle': 'Bandingkan harga neto yang setara dan simpan bukti komersialnya.',
  'stok.sourcing.rfqs': 'Permintaan penawaran',
  'stok.sourcing.rfqsDesc':
    'Terbitkan permintaan, catat jawaban pemasok, dan dokumentasikan pemilihan.',
  'stok.sourcing.newRfq': 'RFQ baru',
  'stok.sourcing.titleField': 'Judul permintaan',
  'stok.sourcing.purpose': 'Tujuan',
  'stok.sourcing.due': 'Batas jawaban',
  'stok.sourcing.catalogue': 'Katalog barang pemasok',
  'stok.sourcing.catalogueDesc':
    'Petakan kemasan pemasok ke barang inventaris sebelum mencatat harga.',
  'stok.sourcing.addSupplierItem': 'Tambah barang pemasok',
  'stok.sourcing.addAgreement': 'Tambah perjanjian',
  'stok.sourcing.supplierSku': 'SKU pemasok',
  'stok.sourcing.purchaseUnit': 'Satuan pembelian',
  'stok.sourcing.leadTime': 'Waktu tunggu (hari)',
  'stok.sourcing.tax': 'Dasar pajak',
  'stok.sourcing.taxExclusive': 'Belum termasuk pajak',
  'stok.sourcing.taxInclusive': 'Termasuk pajak',
  'stok.sourcing.taxExempt': 'Bebas pajak',
  'stok.sourcing.taxRate': 'Tarif pajak (%)',
  'stok.sourcing.reference': 'Referensi',
  'stok.sourcing.validFrom': 'Berlaku mulai',
  'stok.sourcing.validTo': 'Berlaku sampai',
  'stok.sourcing.unitPrice': 'Harga satuan',
  'stok.sourcing.normalized': 'Harga neto ternormalisasi',
  'stok.sourcing.currentTerms': 'Syarat komersial',
  'stok.sourcing.noRfqs': 'Belum ada RFQ.',
  'stok.sourcing.noCatalogue': 'Belum ada pemetaan barang pemasok.',
  'stok.sourcing.noTerms': 'Belum ada riwayat penawaran atau perjanjian.',
  'stok.sourcing.saved': 'Catatan komersial disimpan.',
  'stok.sourcing.created': 'RFQ {number} dibuat.',
  'stok.sourcing.open': 'Buka RFQ {number}',
  'stok.sourcing.openLabel': 'Buka',
  'stok.rfq.issue': 'Terbitkan RFQ',
  'stok.rfq.quote': 'Catat penawaran',
  'stok.rfq.award': 'Pilih pemasok',
  'stok.rfq.comparison': 'Perbandingan ternormalisasi',
  'stok.rfq.comparisonDesc':
    'Harga mengeluarkan pajak inklusif dan memakai satuan tampilan tiap barang.',
  'stok.rfq.total': 'Total pembanding',
  'stok.rfq.validity': 'Masa berlaku',
  'stok.rfq.complete': 'Lengkap',
  'stok.rfq.incomplete': 'Ada baris kosong',
  'stok.rfq.expired': 'Kedaluwarsa atau belum aktif',
  'stok.rfq.reason': 'Alasan pemilihan',
  'stok.rfq.issued': 'RFQ diterbitkan.',
  'stok.rfq.quoted': 'Penawaran pemasok dicatat.',
  'stok.rfq.awarded': 'Pemasok dipilih.',
  'stok.rfq.lines': 'Barang yang diminta',
  'stok.rfq.back': 'Kembali ke penawaran dan perjanjian',
  'stok.rfq.awardReasonHint':
    'Jelaskan harga, mutu, waktu tunggu, ukuran kemasan, atau faktor penentu lain.',

  // ---- Shared ---------------------------------------------------------------------------
  'stok.csv': 'Ekspor CSV',
  'stok.perUnit': 'per {unit}',
  'stok.state.refreshing': 'Memperbarui…',
  'stok.state.stale': 'Gagal memperbarui — data yang tampil mungkin sudah usang.',
  'stok.reason.invalid': 'Tulis antara {min} dan {max} karakter.',
  'stok.badge.lot': 'Lot',
  'stok.badge.expiry': 'Kedaluwarsa',
  'stok.form.name': 'Nama',
  'stok.form.nameRequired': 'Isi nama.',
  'stok.form.tooLong': 'Maksimal {max} karakter.',
  'stok.form.sortOrder': 'Urutan',
  'stok.form.sortOrderHint': 'Angka lebih kecil tampil lebih dulu.',
  'stok.form.sortInvalid': 'Isi bilangan bulat (0 atau lebih).',
  'stok.unit.base.g': 'Gram (ditampilkan dalam kg)',
  'stok.unit.base.ml': 'Mililiter (ditampilkan dalam l)',
  'stok.unit.base.pcs': 'Buah (pcs)',
  'stok.unit.shownIn': 'tampil dalam {unit}',
  'stok.unit.pack': '{name} · {qty}',
  'stok.col.sku': 'SKU',
  'stok.col.item': 'Barang',
  'stok.col.category': 'Kategori',
  'stok.col.qty': 'Jumlah',
  'stok.col.value': 'Nilai',
  'stok.col.avgCost': 'Harga pokok rata-rata',
  'stok.col.unit': 'Satuan',
  'stok.col.reorderPoint': 'Titik reorder',
  'stok.col.reorder': 'Status pesan ulang',
  'stok.col.location': 'Lokasi',
  'stok.col.lot': 'Lot',
  'stok.col.type': 'Jenis mutasi',
  'stok.col.postedAt': 'Waktu posting',
  'stok.col.postedBy': 'Diposting oleh',
  'stok.col.source': 'Sumber',
  'stok.col.date': 'Tanggal',
  'stok.col.businessDate': 'Tanggal bisnis',
  'stok.col.sourceId': 'ID sumber',
  'stok.col.reason': 'Alasan',
  'stok.col.movementCount': 'Mutasi',
  'stok.col.status': 'Status',
  'stok.col.actions': 'Aksi',

  // ---- Filters --------------------------------------------------------------------------
  'stok.filter.title': 'Filter',
  'stok.filter.location': 'Lokasi',
  'stok.filter.allLocations': 'Semua lokasi',
  'stok.filter.search': 'Cari',
  'stok.filter.searchPlaceholder': 'SKU, nama, atau kategori',
  'stok.filter.allItems': 'Semua barang',
  'stok.filter.allTypes': 'Semua jenis',
  'stok.filter.allCategories': 'Semua kategori',
  'stok.filter.allReorder': 'Semua status reorder',
  'stok.filter.allStatuses': 'Semua status',
  'stok.filter.allUnits': 'Semua satuan dasar',
  'stok.filter.allTracking': 'Semua pelacakan',
  'stok.filter.allReasons': 'Semua alasan',
  'stok.filter.allCreators': 'Semua pencatat',
  'stok.filter.allSuppliers': 'Semua pemasok',
  'stok.filter.allKinds': 'Semua jenis lokasi',
  'stok.filter.allTerms': 'Semua termin pembayaran',
  'stok.filter.supplier': 'Pemasok',
  'stok.filter.from': 'Dari',
  'stok.filter.to': 'Sampai',
  'stok.filter.reset': 'Atur ulang filter',
  'stok.filter.rangeOrder': 'Tanggal mulai tidak boleh setelah tanggal akhir.',
  'stok.filter.rangeIncomplete': 'Isi tanggal dengan lengkap.',

  // ---- Reorder --------------------------------------------------------------------------
  'stok.reorder.below': 'Di bawah titik pesan ulang',
  'stok.reorder.ok': 'Cukup',
  'stok.reorder.none': 'Tanpa titik pesan ulang',
  'stok.reorder.point': 'Pesan ulang di {qty}',

  // ---- Stock on hand --------------------------------------------------------------------
  'stok.stock.title': 'Stok tersedia',
  'stok.stock.subtitle': 'Jumlah dan nilai per barang di {branch}.',
  'stok.stock.total': 'Total nilai stok',
  'stok.stock.totalAtLocation': 'Nilai stok di {location}',
  'stok.stock.totalDesc': 'Harga pokok rata-rata tertimbang, dalam {currency}.',
  'stok.stock.asOf': 'Per {time}',
  'stok.stock.itemCount': 'Barang',
  'stok.stock.itemCountDesc': 'Barang aktif, dan barang nonaktif yang masih punya stok.',
  'stok.stock.belowCount': 'Di bawah titik pesan ulang',
  'stok.stock.belowCountDesc': 'Jumlah di cabang kurang dari titik pesan ulang barang.',
  'stok.stock.listTitle': 'Barang',
  'stok.stock.listDesc':
    'Jumlah di cabang beserta rinciannya per lokasi. Nilai adalah pool rata-rata tertimbang yang tepat.',
  'stok.stock.listDescLocation':
    'Jumlah di lokasi ini. Nilai = jumlah × harga pokok rata-rata cabang (turunan).',
  'stok.stock.locationQty': '{location}: {qty}',
  'stok.stock.perLocation': 'Jumlah {item} per lokasi',
  'stok.stock.emptyNoItems': 'Belum ada barang persediaan — buat barang terlebih dahulu.',
  'stok.stock.emptyItemsLink': 'Buka Barang',
  'stok.stock.emptyNoStock':
    'Belum ada stok tercatat. Stok masuk lewat dokumen yang diposting — mulai dengan saldo awal.',
  'stok.stock.emptyLink': 'Catat saldo awal',
  'stok.stock.noMatch': 'Tidak ada barang yang cocok dengan “{query}”.',

  // ---- Valuation ------------------------------------------------------------------------
  'stok.valuation.title': 'Valuasi persediaan',
  'stok.valuation.subtitle':
    'Nilai stok {branch} pada suatu waktu, dihitung dari buku mutasi stok.',
  'stok.valuation.cutoffTitle': 'Batas waktu',
  'stok.valuation.cutoffDesc':
    'Semua mutasi yang diposting sampai waktu ini dihitung. Waktu menurut zona waktu cabang ({timeZone}).',
  'stok.valuation.asOf': 'Nilai per',
  'stok.valuation.now': 'Sekarang',
  'stok.valuation.total': 'Total nilai',
  'stok.valuation.totalDesc': 'Jumlah nilai mutasi yang diposting, dalam {currency}.',
  'stok.valuation.method': 'Metode valuasi',
  'stok.valuation.methodDesc': 'Per cabang dan barang.',
  'stok.valuation.methodWac': 'Rata-rata tertimbang (WAC)',
  'stok.valuation.itemCount': '{count} barang dengan stok atau nilai',
  'stok.valuation.reconciliation': 'Rekonsiliasi',
  'stok.valuation.reconciliationDesc': 'Total buku mutasi dibandingkan dengan pool biaya saat ini.',
  'stok.valuation.reconciled': 'Sesuai',
  'stok.valuation.notReconciled': 'Selisih',
  'stok.valuation.difference': 'Selisih:',
  'stok.valuation.reconciliationNowOnly': 'Hanya diperiksa untuk waktu sekarang. Pilih “Sekarang”.',
  'stok.valuation.byCategory': 'Per kategori',
  'stok.valuation.byCategoryDesc': 'Nilai per kategori barang.',
  'stok.valuation.noCategory': 'Tanpa kategori',
  'stok.valuation.rowsTitle': 'Per barang',
  'stok.valuation.rowsDesc':
    'Nilai tertinggi lebih dulu. Harga pokok rata-rata per kg, liter, atau buah.',
  'stok.valuation.empty':
    'Belum ada nilai stok pada waktu ini — nilai muncul setelah stok diposting.',
  'stok.valuation.definitions': 'Definisi',
  'stok.valuation.definitionsDesc': 'Cara angka dihitung, sesuai yang dikirim server.',
  'stok.valuation.definitionsNone': 'Server tidak mengirim definisi.',
  'stok.valuation.def.method': 'Metode',
  'stok.valuation.def.value': 'Nilai',
  'stok.valuation.def.quantity': 'Jumlah',
  'stok.valuation.def.averageCost': 'Harga pokok rata-rata',
  'stok.valuation.def.reconciliation': 'Rekonsiliasi',
  'stok.valuation.historyTitle': 'Nilai akhir, {days} hari terakhir',
  'stok.valuation.historyDesc': 'Per hari bisnis: nilai masuk, nilai keluar, dan nilai akhir.',
  'stok.valuation.openingValue': 'Nilai sebelum periode ini:',
  'stok.valuation.inbound': 'Masuk',
  'stok.valuation.outbound': 'Keluar',
  'stok.valuation.closing': 'Nilai akhir',

  // ---- Movements ------------------------------------------------------------------------
  'stok.movements.title': 'Mutasi stok',
  'stok.movements.subtitle':
    'Buku mutasi stok {branch}, terbaru di atas. Entri tidak pernah diubah — koreksi dicatat sebagai pembalikan.',
  'stok.movements.listTitle': 'Buku mutasi',
  'stok.movements.listDesc': 'Perubahan jumlah dan nilai per mutasi (+ masuk, − keluar).',
  'stok.movements.loadedNote':
    'Pencarian, pengurutan, dan ekspor mencakup mutasi yang sudah dimuat — muat lagi untuk menyertakan yang lebih lama.',
  'stok.movements.searchPlaceholder': 'Barang, SKU, lot, lokasi, atau sumber',
  'stok.movements.businessDate': 'Tanggal bisnis {date}',
  'stok.movements.reversal': 'Pembalikan',
  'stok.movements.empty': 'Belum ada mutasi stok — mutasi muncul setelah stok diposting.',
  'stok.movements.emptyFiltered': 'Tidak ada mutasi yang cocok dengan filter ini.',
  'stok.movements.loadMore': 'Muat lebih banyak',
  'stok.movements.end': 'Akhir buku mutasi.',
  'stok.type.opening': 'Saldo awal',
  'stok.type.receipt': 'Penerimaan',
  'stok.type.consumption': 'Pemakaian',
  'stok.type.waste': 'Terbuang',
  'stok.type.adjustment': 'Penyesuaian',
  'stok.type.count': 'Stok opname',
  'stok.type.transfer_out': 'Transfer keluar',
  'stok.type.transfer_in': 'Transfer masuk',
  'stok.type.supplier_return': 'Retur ke pemasok',
  'stok.type.revaluation': 'Revaluasi',
  'stok.source.opening_balance': 'Saldo awal',

  // ---- Opening balance ------------------------------------------------------------------
  'stok.opening.title': 'Saldo awal',
  'stok.opening.subtitle': 'Catat stok awal beserta harga pokoknya di satu lokasi di {branch}.',
  'stok.opening.readOnly':
    'Peran Anda dapat melihat stok, tetapi tidak dapat memposting saldo awal.',
  'stok.opening.noPermission':
    'Memposting saldo awal memerlukan izin penyesuaian stok. Hubungi manajer.',
  'stok.opening.noItems': 'Belum ada barang aktif — buat barang sebelum mencatat stok.',
  'stok.opening.noLocations': 'Belum ada lokasi aktif — buat lokasi terlebih dahulu.',
  'stok.opening.headTitle': 'Lokasi',
  'stok.opening.headDesc': 'Semua baris diposting ke lokasi ini dalam satu dokumen.',
  'stok.opening.reason': 'Catatan',
  'stok.opening.reasonHint': 'Misalnya: “Stok opname saat mulai memakai sistem”.',
  'stok.opening.linesTitle': 'Baris',
  'stok.opening.linesDesc': 'Satu baris per barang (per lot untuk barang ber-lot), maksimal {max}.',
  'stok.opening.lineLabel': 'Baris {n}',
  'stok.opening.removeLine': 'Hapus baris {n}',
  'stok.opening.pickItem': 'Pilih barang…',
  'stok.opening.qty': 'Jumlah',
  'stok.opening.unit': 'Satuan',
  'stok.opening.cost': 'Harga per {unit} ({currency})',
  'stok.opening.costHint': 'Angka saja, dalam satuan terkecil — untuk IDR artinya rupiah.',
  'stok.opening.lot': 'Kode lot',
  'stok.opening.expiry': 'Tanggal kedaluwarsa',
  'stok.opening.shelfLifeHint': 'Masa simpan: {days} hari.',
  'stok.opening.inBase': 'Setara',
  'stok.opening.lineValue': 'Nilai baris',
  'stok.opening.addLine': 'Tambah baris',
  'stok.opening.total': 'Total nilai',
  'stok.opening.onceNote':
    'Saldo awal hanya dapat diposting sekali per barang dan lokasi; koreksi berikutnya lewat stok opname.',
  'stok.opening.review': 'Tinjau dan posting',
  'stok.opening.confirmTitle': 'Posting saldo awal?',
  'stok.opening.confirmBody': '{count} baris akan diposting ke {location}.',
  'stok.opening.confirmWarning':
    'Mutasi yang sudah diposting tidak dapat diubah. Periksa jumlah, satuan, dan harganya.',
  'stok.opening.confirm': 'Posting',
  'stok.opening.posting': 'Memposting…',
  'stok.opening.posted': 'Saldo awal diposting ({count} mutasi).',
  'stok.opening.resultTitle': 'Saldo awal diposting',
  'stok.opening.resultDesc': 'Mutasi berikut sudah masuk ke buku mutasi stok.',
  'stok.opening.viewLedger': 'Lihat mutasi',
  'stok.opening.err.location': 'Pilih lokasi.',
  'stok.opening.err.reason': 'Maksimal 200 karakter.',
  'stok.opening.err.noLines': 'Tambahkan minimal satu baris.',
  'stok.opening.err.tooManyLines': 'Maksimal 100 baris per dokumen.',
  'stok.opening.err.item': 'Pilih barang.',
  'stok.opening.err.qty': 'Isi jumlah di atas 0 (maksimal 3 desimal).',
  'stok.opening.err.unit': 'Pilih satuan untuk barang ini.',
  'stok.opening.err.precision':
    'Jumlah ini tidak dapat dikonversi dengan tepat — gunakan satuan yang lebih kecil.',
  'stok.opening.err.cost': 'Isi harga dengan angka (0 atau lebih).',
  'stok.opening.err.tooLarge': 'Nilai baris ini terlalu besar.',
  'stok.opening.err.lot': 'Isi kode lot.',
  'stok.opening.err.lotLength': 'Maksimal 40 karakter.',
  'stok.opening.err.expiry': 'Isi tanggal kedaluwarsa.',
  'stok.opening.err.duplicate': 'Barang (dan lot) ini sudah ada di baris lain.',
  'stok.opening.err.hasMovements':
    'Barang ini sudah punya mutasi di lokasi ini — gunakan stok opname.',
  'stok.opening.err.lotExpiryConflict': 'Lot ini sudah ada dengan tanggal kedaluwarsa lain.',

  // ---- Items ----------------------------------------------------------------------------
  'stok.items.title': 'Barang',
  'stok.items.subtitle': 'Barang persediaan dipakai bersama oleh semua cabang usaha.',
  'stok.items.readOnly':
    'Hanya peran yang mengelola persediaan untuk seluruh usaha yang dapat mengubah barang.',
  'stok.items.add': 'Tambah barang',
  'stok.items.listTitle': 'Barang persediaan',
  'stok.items.listDesc': 'Satuan dasar, pelacakan, titik pesan ulang, dan satuan kemasan.',
  'stok.items.empty': 'Belum ada barang — tambahkan bahan dan barang yang Anda simpan di stok.',
  'stok.items.emptyReadOnly': 'Belum ada barang — manajer yang menambahkannya.',
  'stok.items.baseUnit': 'Satuan dasar',
  'stok.items.baseUnitHint': 'Stok disimpan dalam satuan ini. Tidak dapat diubah nanti.',
  'stok.items.baseUnitLocked': 'Satuan dasar tidak dapat diubah setelah dibuat.',
  'stok.items.tracking': 'Pelacakan',
  'stok.items.trackingNone': 'Tidak dilacak',
  'stok.items.trackingLot': 'Lot',
  'stok.items.trackingLotExpiry': 'Lot dan kedaluwarsa',
  'stok.items.reorderPoint': 'Titik pesan ulang',
  'stok.items.reorderPointIn': 'Titik pesan ulang ({unit}, opsional)',
  'stok.items.reorderPointHint':
    'Ditandai “di bawah titik pesan ulang” saat stok cabang kurang dari angka ini.',
  'stok.items.packUnits': 'Satuan kemasan',
  'stok.items.editNamed': 'Ubah {name}',
  'stok.items.createTitle': 'Barang baru',
  'stok.items.editTitle': 'Ubah barang',
  'stok.items.formDesc': 'Data induk untuk semua cabang.',
  'stok.items.skuHint': 'Huruf, angka, titik, tanda hubung, dan garis bawah.',
  'stok.items.shelfLife': 'Masa simpan dalam hari',
  'stok.items.shelfLifeHint': 'Membantu saat mengisi tanggal kedaluwarsa.',
  'stok.items.lotTracked': 'Lacak lot',
  'stok.items.lotTrackedHint': 'Setiap penerimaan dan saldo awal mencantumkan kode lot.',
  'stok.items.expiryTracked': 'Lacak tanggal kedaluwarsa',
  'stok.items.expiryTrackedHint': 'Setiap lot memiliki tanggal kedaluwarsa. Perlu pelacakan lot.',
  'stok.items.active': 'Aktif',
  'stok.items.activeHint': 'Barang nonaktif tidak dapat menerima stok baru.',
  'stok.items.createSubmit': 'Buat barang',
  'stok.items.saved': '{name} disimpan.',
  'stok.items.err.skuRequired': 'Isi SKU.',
  'stok.items.err.skuFormat': 'Gunakan huruf, angka, titik, tanda hubung, atau garis bawah saja.',
  'stok.items.err.skuTaken': 'Sudah ada barang dengan SKU ini.',
  'stok.items.err.shelfLife': 'Isi jumlah hari dari 1 sampai 3650.',
  'stok.items.err.reorderPoint': 'Isi jumlah 0 atau lebih (titik atau koma untuk desimal).',
  'stok.items.err.expiryNeedsLot': 'Pelacakan kedaluwarsa memerlukan pelacakan lot.',
  'stok.items.err.lotLocked': 'Pelacakan lot tidak dapat diubah setelah stok diposting.',

  // ---- Pack units -----------------------------------------------------------------------
  'stok.units.title': 'Satuan kemasan',
  'stok.units.desc':
    'Satuan untuk membeli atau menghitung barang ini, misalnya karung 25 kg. Selalu tersedia: g/kg, ml/l, atau pcs. Ditampilkan dalam {unit}.',
  'stok.units.empty': 'Belum ada satuan kemasan.',
  'stok.units.factor': '1 {unit} = {qty}',
  'stok.units.code': 'Kode',
  'stok.units.contains': 'Isi',
  'stok.units.add': 'Tambah satuan',
  'stok.units.added': 'Satuan {name} ditambahkan.',
  'stok.units.activate': 'Aktifkan',
  'stok.units.deactivate': 'Nonaktifkan',
  'stok.units.activateNamed': 'Aktifkan satuan {name}',
  'stok.units.deactivateNamed': 'Nonaktifkan satuan {name}',
  'stok.units.activated': 'Satuan diaktifkan.',
  'stok.units.deactivated': 'Satuan dinonaktifkan.',
  'stok.units.err.code': 'Gunakan 1–12 huruf kecil, angka, tanda hubung, atau garis bawah.',
  'stok.units.err.standard': 'Ini satuan standar — selalu tersedia.',
  'stok.units.err.codeTaken': 'Barang ini sudah punya satuan dengan kode ini.',
  'stok.units.err.factor': 'Isi jumlah di atas 0 yang dapat dikonversi dengan tepat.',

  // ---- Locations ------------------------------------------------------------------------
  'stok.locations.title': 'Lokasi',
  'stok.locations.subtitle': 'Tempat stok disimpan di {branch}.',
  'stok.locations.readOnly': 'Peran Anda dapat melihat lokasi, tetapi tidak dapat mengubahnya.',
  'stok.locations.add': 'Tambah lokasi',
  'stok.locations.listTitle': 'Lokasi stok',
  'stok.locations.listDesc': 'Lokasi utama otomatis terpilih di dokumen stok.',
  'stok.locations.searchPlaceholder': 'Kode, nama, atau jenis',
  'stok.locations.empty': 'Belum ada lokasi — tambahkan gudang terlebih dahulu.',
  'stok.locations.emptyReadOnly': 'Belum ada lokasi — manajer yang menambahkannya.',
  'stok.locations.code': 'Kode',
  'stok.locations.codeHint':
    'Huruf kapital, angka, dan tanda hubung, misalnya GDG. Tidak dapat diubah nanti.',
  'stok.locations.codeLocked': 'Kode tidak dapat diubah setelah dibuat.',
  'stok.locations.kind': 'Jenis',
  'stok.locations.default': 'Utama',
  'stok.locations.defaultBadge': 'Utama',
  'stok.locations.defaultName': '{name} (utama)',
  'stok.locations.inactiveName': '{name} (nonaktif)',
  'stok.locations.defaultLabel': 'Lokasi utama',
  'stok.locations.defaultHint':
    'Menggantikan lokasi utama saat ini. Untuk menggantinya, pilih lokasi utama lain.',
  'stok.locations.activeLabel': 'Aktif',
  'stok.locations.activeHint':
    'Hanya lokasi kosong yang dapat dinonaktifkan; lokasi utama tidak bisa.',
  'stok.locations.editNamed': 'Ubah {name}',
  'stok.locations.createTitle': 'Lokasi baru',
  'stok.locations.editTitle': 'Ubah lokasi',
  'stok.locations.formDesc': 'Gudang, dapur, bar, atau tempat lain yang menyimpan stok.',
  'stok.locations.createSubmit': 'Buat lokasi',
  'stok.locations.saved': '{name} disimpan.',
  'stok.locations.err.code': 'Gunakan 1–12 huruf kapital, angka, atau tanda hubung.',
  'stok.locations.err.codeTaken': 'Sudah ada lokasi dengan kode ini.',
  'stok.locations.err.hasStock':
    'Pindahkan atau hitung habis stoknya sebelum menonaktifkan lokasi ini.',
  'stok.locations.err.defaultInactive': 'Lokasi utama tidak dapat dinonaktifkan.',
  'stok.locations.err.keepDefault': 'Pilih lokasi utama lain sebagai gantinya.',
  'stok.kind.storage': 'Gudang',
  'stok.kind.kitchen': 'Dapur',
  'stok.kind.bar': 'Bar',
  'stok.kind.other': 'Lainnya',
  'stok.kind.quarantine': 'Karantina',
};
